import axios from 'axios';

export class Requests {
  constructor() {
    this.loading = false;

    this.shortstar_base_url = document.body.querySelector('input[name="_baseUrl"]').value;

    if (!this.shortstar_base_url) {
      this.shortstar_base_url = document.querySelector('div#noip-cart').getAttribute('data-shortstar_base_url');

      this.shortstar_base_url = this.shortstar_base_url ? this.shortstar_base_url : '';

      // Remove trailing slash
      if (this.shortstar_base_url && this.shortstar_base_url.endsWith('/')) {
        this.shortstar_base_url = this.shortstar_base_url.slice(0, -1);
      }
    }
  }

  isLoading() {
    return this.loading;
  }

  getCartContents() {
    return this.sendRequest('/plan-builder/get-products', [], false);
  }

  deleteItem(item_id) {
    return this.sendRequest('/plan-builder/remove-product', { item_id: item_id });
  }

  addItems(json_items) {
    return this.sendRequest('/plan-builder/add-products', json_items);
  }

  sendRequest(endpoint, data, block_multi_requests = true) {
    var headers = {
      'X-CSRF-TOKEN': this.getCsrfToken(),
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // For Request::Ajax()
    };

    if (document.querySelector('div#noip-cart')) {
      headers['X-Cart-Key'] = this.getCartKey();
    }

    this.loading = !!block_multi_requests;

    return axios({
      method: 'post',
      url: this.shortstar_base_url + endpoint,
      headers: headers,
      data: JSON.stringify(data)
    })
      .then(response => {
        this.loading = false;
        return response.data;
      })
      .catch(() => {
        this.loading = false;
        return {};
      });
  }

  getCsrfToken() {
    return String(document.querySelector('#cartCsrfToken').getAttribute('data-token'));
  }

  getCartKey() {
    return String(document.querySelector('div#noip-cart').getAttribute('data-cart_key'));
  }
}
